import { tokenManager } from "../api/utils/tokenManager";
import { API_CONFIG } from "../config/urls";
import axios from "axios";
import { ApiError } from "../api/types";
import noImg from "../assets/images/no-image.png";
import { api } from "../api/Api";
import Toast from "../services/Toast";
import { Menu, Permission } from "../types/auth";
import { Item, ItemBatch, ItemSerial, Warehouse, WarehouseShelf } from "../types/models";

// Export individual functions
export const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
};

export function capitalizeFirstLetter(string: string | any) : string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function roundToDecimalPlace(number: number, decimalPlaces = 2) {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}

export function moduleToTitle(str: string): string {
  return str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export const filterArrayByKeyValue = <T>(
  array: T[],
  key: keyof T,
  value: any
): T[] => {
  return array.filter((item) => item[key] === value);
};

/**
 * Check if Permission is true
 * @param permissions Feature Permissions List
 * @param permission ZPermission to Check
 * @returns True if allowed, false otherwise
 */
export const hasPermission = (
  permissions?: Permission[],
  permission?: string
): boolean => {
  return (
    permissions?.some(
      (item) =>
        item.permission?.toLocaleLowerCase() === permission?.toLocaleLowerCase()
    ) ?? false
  );
};

/**
 * Get the Mermissions List
 * @param path Router Path to get the Permissions
 * @returns Permission List
 */
export const getPermissionList = (path: string): Permission[] => {
  const perm: Permission[] = tokenManager.getPermissions();
  path = path.replace('/clients/', '')
  path = path.replace('clients/', '')
  path = path.endsWith('/') ? path.slice(0, -1) : path;
  if (path.endsWith('-')) {
      const lastSlashIndex = path.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        path =  path.substring(0, lastSlashIndex);
      }
  }
  const permissions: Permission[] = perm.filter(function (itm) {
    return itm.route_path == path;
  });
  return permissions;
};

export const getMenuFromPath = (path: string): Menu | null => {
  path = path.replace('/clients/', '')
  path = path.replace('clients/', '')
  path = path.endsWith('/') ? path.slice(0, -1) : path;
  if (path.endsWith('-')) {
      const lastSlashIndex = path.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        path =  path.substring(0, lastSlashIndex);
      }
  }
  return tokenManager.getMenu()?.find((e: Menu) => e.route_path == path) || null
};

export const filterArrayByKeyValuePartial = <T>(
  array: T[],
  key: keyof T,
  value: any
): T[] => {
  return array.filter((item) => {
    const itemValue = item[key];
    if (typeof itemValue === "string" && typeof value === "string") {
      return itemValue.toLowerCase().includes(value.toLowerCase());
    }
    return itemValue === value;
  });
};

export const filterArrayByMultipleConditions = <T>(
  array: T[],
  conditions: Partial<Record<keyof T, any>>
): T[] => {
  return array.filter((item) => {
    return Object.entries(conditions).every(([key, value]) => {
      return item[key as keyof T] === value;
    });
  });
};

export const hasObjectWithKeyValue = <T>(
  array: T[],
  key: keyof T,
  value: any
): boolean => {
  return array.some((item) => item[key] === value);
};

export const formatDate = (
  date: Date | string = new Date(),
  format: string = "yyyy-mm-dd"
): string => {
  const d = new Date(date);

  if (isNaN(d.getTime())) {
    return "";
  }

  const padZero = (num: number): string =>
    num < 10 ? `0${num}` : num.toString();

  const year = d.getFullYear();
  const month = padZero(d.getMonth() + 1);
  const day = padZero(d.getDate());
  const hours = padZero(d.getHours());
  const minutes = padZero(d.getMinutes());
  const seconds = padZero(d.getSeconds());

  return format
    .replace("yyyy", year.toString())
    .replace("mm", month)
    .replace("dd", day)
    .replace("HH", hours)
    .replace("MM", minutes)
    .replace("SS", seconds);
};

export const formatCurrency = (
  amount: number,
  format: string = "MVR"
): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: format,
  }).format(amount);
};

export const formatNumber = (
  number?: number,
  decimals: number = 2,
  minDecimals = 2,
  ignoreZero: boolean = false
): string => {
  if (!number) return ignoreZero ? '' : "0.00";
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimals == 0 ? 0 : minDecimals,
    maximumFractionDigits: decimals,
  });
  if (ignoreZero && number == 0) {
    return '';
  }
  return formatter.format(number);
};

export const documentActions = async (
  endPoint: string,
  id: string | number,
  action: string,
  title: string = "",
) => {

  console.log("documentActions", endPoint, id, action);
  if (action == "mail") {
    emailPDF(endPoint, id);
    return;
  }

  const params = {
    id: id,
  };
  const response = await api.post(
    (endPoint.slice(-1) == "/" ? endPoint : endPoint + "/") + "print",
    params
  );
  if (response.success == true) {
    if (action == "download") {
      downloadPDFBlob(response.data, title);
      //downloadPDF(response.data.file);
    } else if (action == "share") {
      sharePDFBlob(response.data, title);
      /*sharePDF(response.data.file, 
        response.data.data ? (
          response.data.data.customer ? response.data.data.customer.name + "(#" + response.data.data.document_no + ")" : 
          response.data.data.vendor.name + "(#" + response.data.data.document_no + ")"
        ) : "File from Faseyha POS", "viber");*/
    } else if (action == "print") {
      //printPDF(response.data.file)
      //console.log('response.data', response.data)
      printPDFBlob(response.data, title)
    }
  }
};

export const downloadPDFBlob = async (fildata: any, title = 'File') => {
  try {
    
    //const data = await fildata.json(); // Assume the API returns { file: "<base64_string>" }
    //const base64Content = data.file; // Replace 'file' with your actual key from the response

    // Step 2: Decode the Base64 string and create a Blob
    const binaryString = atob(fildata);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    let fileName = title.replace(/[^a-zA-Z0-9]/g, "_") + '.pdf' 
    link.download = fileName + ".pdf"; // Specify the filename
    link.click();

    // Step 4: Clean up the Object URL
    URL.revokeObjectURL(link.href);

  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};


export const downloadPDF = async (url: string) => {
  url = API_CONFIG.STORAGE_URL + url;
  //url = 'https://api-medlab.healthpack.mv/storage/memos/memo_43916_2025_02_09_20_32_.pdf'
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Create a hidden <a> element for downloading
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = getUrlFileName(url); // Change filename if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup the URL object
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

export const printPDF = async (pdfUrl: string) => {
  pdfUrl = API_CONFIG.STORAGE_URL + pdfUrl;
  console.log('printPDF pdfUrl', pdfUrl)
  //pdfUrl = 'https://api-medlab.healthpack.mv/storage/memos/memo_43916_2025_02_09_20_32_.pdf'
  try {
    const response = await fetch(pdfUrl);
    const blob = await response.blob();
    const pdfBlobUrl = URL.createObjectURL(blob);

    let pdfFrame = document.getElementById("pdf-printer") as HTMLIFrameElement;
    if (pdfFrame) {
      pdfFrame.src = pdfBlobUrl;
      pdfFrame.onload = () => {
        pdfFrame?.contentWindow?.focus();
        pdfFrame?.contentWindow?.print();
      };
    }
  } catch (error) {
    console.error("Error fetching PDF:", error);
  }
};

export const printPDFBlob = async (data: any, _title = "") => {
  const base64 = data.includes(",") ? data.split(",")[1] : data;

  // Clean base64 (remove whitespace/newlines)
  const cleaned = base64.replace(/\s/g, "");

  // Fix padding length if needed
  const padded =
    cleaned + "=".repeat((4 - (cleaned.length % 4)) % 4);

  const binaryData = atob(padded);

  const len = binaryData.length;
  const uint8Array = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: "application/pdf" });
  const blobURL = URL.createObjectURL(blob);

  const pdfFrame = document.getElementById("pdf-printer") as HTMLIFrameElement | null;

  if (pdfFrame) {
    pdfFrame.src = blobURL;
    pdfFrame.onload = () => {
      pdfFrame.contentWindow?.focus();
      pdfFrame.contentWindow?.print();
    };
  } else {
    // fallback open in new tab
    window.open(blobURL);
  }
}

export const printLabel = async (barcode: string, name: string, price: string, outlets_id: string) => {
  const response = await api.post("/clients/inventory/item-management/items/label",
    {
      barcode: barcode,
      name: name,
      price: formatNumber(Number(price)),
      outlets_id: outlets_id,
    }
  );
  if (response.success == true) {
    const binaryData = atob(response.data);

    // Step 2: Create a Uint8Array to store the binary data
    const len = binaryData.length;
    const uint8Array = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Step 3: Create a Blob from the binary data
    const blob = new Blob([uint8Array], { type: "application/pdf" });

    // Step 4: Create a Blob URL
    const blobURL = URL.createObjectURL(blob);

    let pdfFrame = document.getElementById("pdf-printer") as HTMLIFrameElement;
  if (pdfFrame) {
    pdfFrame.src = blobURL;
    pdfFrame.onload = () => {
      pdfFrame?.contentWindow?.focus();
      pdfFrame?.contentWindow?.print();
    };
  }
  }
}

export const emailPDF = async (url: string, id: string | number) => {
  const response = await api.post(
    (url.slice(-1) == "/" ? url : url + "/") + "email",
    {
      id: id,
    }
  );
  if (response.success == true) {
    Toast.show("Emailed successfully");
  }
};

export const sharePDFBlob = async (fileData: any, text: string = 'Attachment') => {
  //url = 'https://bs.faseyhapos.mv/storage/e3990d93-14ec-4084-ad97-ef3116f2e9b2/temp/invoice_512025_02_13_15_08.pdf'
  if (navigator.share) {
    try {

      const binaryData = atob(fileData);

    // Step 2: Create a Uint8Array to store the binary data
    const len = binaryData.length;
    const uint8Array = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Step 3: Create a Blob from the binary data
    const blob = new Blob([uint8Array], { type: "application/pdf" });

      let fileName = text.replace(/[^a-zA-Z0-9]/g, "_") + '.pdf' //= getUrlFileName(url); // Ensure this function extracts the filename correctly
      const file = new File([blob], fileName, { type: "application/pdf" });

      await navigator.share({
        title: "Faseyha POS",
        text: text,
        files: [file],
      });

      //console.log("PDF shared successfully!");
    } catch (error) {
      console.log(error);
      Toast.show("Could not share", "warning");
    }
  } 
};

export const sharePDF = async (url: string, text: string, type: string) => {
  url = API_CONFIG.STORAGE_URL + url;
  //url = 'https://bs.faseyhapos.mv/storage/e3990d93-14ec-4084-ad97-ef3116f2e9b2/temp/invoice_512025_02_13_15_08.pdf'
  if (navigator.share) {
    try {
      const response = await axios.get(url, {
        responseType: "blob", // Ensure the response is treated as a file
        headers: {
          Authorization: `Bearer ${tokenManager.get()}`,
          Accept: "application/pdf",
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      let fileName = getUrlFileName(url); // Ensure this function extracts the filename correctly
      const file = new File([blob], fileName, { type: "application/pdf" });

      await navigator.share({
        title: "Faseyha POS",
        text: text,
        files: [file],
      });

      //console.log("PDF shared successfully!");
    } catch (error) {
      console.log(error);
      Toast.show("Could not share", "warning");
    }
  } else {
    // Fallback for WhatsApp & Viber (when Web Share API is not supported)
    const encodedUrl = encodeURIComponent(url);
    //${encodeURIComponent(props.text)}
    if (type == "whatsapp") {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        text
      )}:+${encodedUrl}`;
      window.open(whatsappUrl, "_blank");
    } else {
      const viberUrl = `viber://forward?text=${encodeURIComponent(
        text
      )}:+${encodedUrl}`;
      window.open(viberUrl, "_blank");
    }
  }
};

export  const toTitle = (input: string | null): string => {
  if (input == null) {
    return '';
  }
  return input.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()).trim();
};

export const getImage = async (url: string) => {
  try {
    if (
      url == "" ||
      url == null ||
      url == undefined
    ) {
      return "";
    }
    const response = await getBase64Image(
      Array.isArray(url) ? url[0] : url
    );
    return response.success && response.data ? response.data : "";
  } catch (e) {
    return "";
  }
};

export const getBase64Image = async (url: string) => {
  if (isEmpty(url)) {
    return {
      success: false,
      data: noImg,
    };
  }
  try {
    const response = await axios.get(API_CONFIG.STORAGE_URL + url, {
      responseType: "arraybuffer",
    });

    const contentType = response.headers["content-type"];
    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );
    const base64String = `data:${contentType};base64,${base64}`;

    return {
      success: true,
      data: base64String,
    };
  } catch (error) {
    //console.error('Error converting image:', error); //TODO: common error login
    const apiError = error as ApiError;
    return {
      success: false,
      data: noImg,
      error: {
        message: "Failed to convert image to base64",
        code: apiError.code,
      },
    };
  }
};

export const setDefaultImage = (event: Event): void => {
  const target = event.target as HTMLImageElement;
  if (target.src !== noImg) {
    target.src = noImg;
  }
};

export const toBool = (
  value: string | number | boolean | null | undefined
): boolean => {
  if (value === "true" || value === 1 || value === "1") {
    return true;
  }
  if (value === "false" || value === 0 || value === "0" || value === false) {
    return false;
  }
  return Boolean(value);
};

export function isNumeric(value: any): boolean {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

export const getToday = (): string => {
  const date = new Date();

  // Get the year, month, and day
  const year = date.getFullYear();
  let month: string | number = date.getMonth() + 1;
  let day: string | number = date.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  month = month.toString();
  day = day.toString();

  return `${year}-${month}-${day}`;
};

export const formatHumanDate = (
  date: Date | string,
  includeTime: boolean = false
): string => {
  const d = new Date(date);

  if (isNaN(d.getTime())) {
    return "";
  }

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  const timeStr = includeTime
    ? ` at ${d.getHours()}:${d.getMinutes().toString().padStart(2, "0")}`
    : "";

  if (diffSecs < 60) return "just now";
  if (diffMins < 60)
    return `${diffMins} minute${diffMins !== 1 ? "s" : ""} ago`;
  if (diffHours < 24)
    return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
  if (diffDays === 1) return `yesterday${timeStr}`;
  if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}${timeStr}`;
};

export const validatePurchaseGrid = async (items: Item[], warehouse?: Warehouse): Promise<boolean> => {
  for (const item of items) {
    if (item.code && item.name && item.items_id && (item.inventory_qty ?? 0)  > 0) {
      if (item.tracked_by === "Batch") {
      const batch_qty = item.batches?.reduce(
        (sum: number, batch: ItemBatch) => {
          if (
            typeof batch.quantity === "number" &&
            batch.batch_no &&
            (!item.is_expiry || batch.expiry_date) &&
            (!warehouse?.shelf_managed || batch.warehouse_shelfs_id)
          ) {
            return sum + batch.quantity;
          }
          return sum;
        },
        0
      );
      console.log('batch_qty', batch_qty, 'item.inventory_qty', item.inventory_qty)
      if (batch_qty !== item.inventory_qty) {
        return false;
      }
    } else if (item.tracked_by === "Serial") {
      const serial_qty = item.serials?.reduce(
        (sum: number, serial: ItemSerial) => {
          if (
            typeof serial.quantity === "number" &&
            serial.serial_no &&
            (!item.is_expiry || serial.expiry_date) &&
            (!warehouse?.shelf_managed || serial.warehouse_shelfs_id)
          ) {
            return sum + serial.quantity;
          }
          return sum;
        },
        0
      );
      if (serial_qty !== item.inventory_qty) {
        return false;
      }
    } else if (warehouse?.shelf_managed) {
      const shelf_qty = item.shelfs?.reduce(
        (sum: number, shelf: WarehouseShelf) => {
          if (
            typeof shelf.quantity === "number"
          ) {
            return sum + shelf.quantity;
          }
          return sum;
        },
        0
      );
      if (shelf_qty !== item.inventory_qty) {
        return false;
      }
    }
    }
  } 
  return true;
};

export const timeSince = (date: Date | string): string => {
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return "";
  }

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);

  if (diffMins < 60) {
    return `${diffMins} minute${diffMins !== 1 ? "s" : ""}`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? "s" : ""}`;
  } else {
    return `${Math.floor(diffHours / 24)} day${Math.floor(diffHours / 24) !== 1 ? "s" : ""}`;
  }
};

const getUrlFileName = (url: string): string => {
  return new URL(url).pathname.split("/").pop() || "";
};


export const receiptTypes = (): { id: string; name: string }[] => {
  return [
    {id: 'Thermal', name: 'Thermal'},
    {id: 'Paper', name: 'Paper'}
  ]
}

export const receiptSizes = (): { id: string; name: string }[] => {
  return [
    {id: '80mm', name: '80mm'},
    {id: '50mm', name: '50mm'},
    {id: 'A5', name: 'A5'},
    {id: 'A4', name: 'A4'}
  ]
}

export const copyText = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      const animationElement = document.createElement("div");
      animationElement.className = "copy-animation";
      animationElement.innerHTML = "Copied!";
      document.body.appendChild(animationElement);

      setTimeout(() => {
        animationElement.classList.add("fade-out");
      }, 500);

      setTimeout(() => {
        document.body.removeChild(animationElement);
      }, 1000);
    })
    .catch((err) => {
      Toast.show("Failed to copy Memo No: " + err.message, "error");
      console.error("Failed to copy text: ", err);
    });
};


// Keep the class for backward compatibility
export class CommonFunctions {
  static isEmpty = isEmpty;
  static filterArrayByKeyValue = filterArrayByKeyValue;
  static filterArrayByKeyValuePartial = filterArrayByKeyValuePartial;
  static filterArrayByMultipleConditions = filterArrayByMultipleConditions;
  static hasObjectWithKeyValue = hasObjectWithKeyValue;
  static formatDate = formatDate;
  static formatHumanDate = formatHumanDate;
  static hasPermission = hasPermission;
  static getPermissionList = getPermissionList;
  static formatCurrency = formatCurrency;
  static formatNumber = formatNumber;
  static getToday = getToday;
  static toBool = toBool;
  static downloadPDF = downloadPDF;
  static getUrlFileName = getUrlFileName;
  static printPDF = printPDF;
  static getBase64Image = getBase64Image;
  static emailPDF = emailPDF;
  static sharePDF = sharePDF;
  static documentActions = documentActions;
  static isNumeric = isNumeric;
  static capitalizeFirstLetter = capitalizeFirstLetter;
  static receiptTypes = receiptTypes
  static receiptSizes = receiptSizes
  static moduleToTitle = moduleToTitle
  static printLabel = printLabel
  static copyText = copyText
  static printPDFBlob = printPDFBlob
  static roundToDecimalPlace = roundToDecimalPlace
  static getImage = getImage
}
